import type { MessageDescriptor } from 'react-intl';
import { castMessages as messages } from '../messages/castMessages';
import type { CastUploadError } from './useCastUpload';

const MESSAGES: Readonly<Record<CastUploadError, MessageDescriptor>> = {
  type: messages.errorType,
  size: messages.errorSize,
  upload: messages.errorUpload,
  consent: messages.errorConsent,
  pictures: messages.errorPictures,
  castFull: messages.errorCastFull,
  busy: messages.errorBusy,
  videoLimit: messages.errorVideoLimit,
  dayLimit: messages.errorDayLimit,
  stale: messages.errorStale,
  step: messages.errorFailed,
  castPending: messages.castNotReady,
  artistPicture: messages.errorArtistPicture,
  demo: messages.errorDemo,
  failed: messages.errorFailed,
};

/** The sentence of a refused cast action (design b3, c4). */
export function castErrorMessage(error: CastUploadError): MessageDescriptor {
  return MESSAGES[error];
}
